module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAATCAYAAAAQ/xqmAAAAAXNSR0IArs4c6QAAAPNJREFUWAnt2DEKwkAQheFEo2ChVoL3sfCOegC1E+xE7LX1KB4g/gMhGLJkBzLlW3gYN+MrPpagFoXWKIG6rq/kQdZDRZOhm7rnEvgytSP3HLarTUNpAXDn5EZsvcjgyU63aNclAK6wXVIBQ8IOQPRWCNsrFTAn7ABEb0UKu2TzSMHeW6I5t8CMyW0z/ay4WJJVs6GXOIH/3yiLuFo1tQI8JabkRGx9yKa9qYsYAVAN+UxsCTmGtdsCrJC7JPHvhBxv2msEuSIXYkuPi55QwAawQg5wzFYAfbBjzNJJzmqNGADY/vR/E32FG+GY/SjAZXaIgR/AlgKFWdofdAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/SignUpSection/icArrow.png
// module id = 1002
// module chunks = 0